import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import Image from '@nerdwallet/react-image';
import { Link, Text, Type, Box } from '@nerdwallet/currency';

const CompanyEngBlogTile = ({ featuredMedia, link, title }) => {
  const imageUrl =
    featuredMedia?.sourceUrl ||
    'https://www.nerdwallet.com/assets/img/nw-logos/NW_logo_200x200.png';

  return (
    <Box
      className={classNames([
        'eng-blog__tile',
        classes('margin-horizontal-auto'),
        classes('margin-horizontal-0--wide'),
        classes('padding-right-4--wide'),
        classes('margin-bottom-5'),
        classes('margin-bottom-4--wide'),
      ])}
    >
      <Link href={link} key={title.rendered} color="neutral-darkest">
        <div>
          {imageUrl && (
            <div>
              <Image
                src={imageUrl}
                alt={title.rendered}
                objectFit="cover"
                naturalHeight={220}
                naturalWidth={367}
                backgroundColor="transparent"
                imageClassName={classNames([
                  'eng-blog__image',
                  classes('margin-bottom-3'),
                ])}
              />
            </div>
          )}
        </div>
        <div>
          <div
            className={classNames([
              'eng-blog__title',
              classes('margin-bottom-2'),
              classes('text-align-left'),
              classes('display-block'),
            ])}
          >
            <Text bold>{title}</Text>
          </div>
          <Type
            size="2"
            default
            color="blue"
            className={classNames([
              'eng-blog__excerpt',
              classes('text-align-left'),
              classes('display-block'),
            ])}
          >
            Read more
          </Type>
        </div>
      </Link>
    </Box>
  );
};

CompanyEngBlogTile.propTypes = {
  featuredMedia: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string,
};

CompanyEngBlogTile.displayName = 'Company Engineering Blog Tile';

export default CompanyEngBlogTile;
